(function () {
  function bindVerticalUnlock(track) {
    var startX = 0;
    var startY = 0;
    var axis = null;

    track.addEventListener(
      'touchstart',
      function (e) {
        if (!e.touches || e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        axis = null;
      },
      { passive: true }
    );

    track.addEventListener(
      'touchmove',
      function (e) {
        if (!e.touches || e.touches.length !== 1 || axis === 'x') return;
        var dx = e.touches[0].clientX - startX;
        var dy = e.touches[0].clientY - startY;
        var absX = Math.abs(dx);
        var absY = Math.abs(dy);

        if (axis === null) {
          if (absX < 6 && absY < 6) return;
          axis = absY > absX ? 'y' : 'x';
        }

        if (axis === 'y') {
          track.style.overflowX = 'hidden';
        }
      },
      { passive: true }
    );

    function unlockTrack() {
      track.style.overflowX = '';
      axis = null;
    }

    track.addEventListener('touchend', unlockTrack, { passive: true });
    track.addEventListener('touchcancel', unlockTrack, { passive: true });
  }

  function initGifts(root) {
    if (!root || root.dataset.egInit === 'true') return;
    root.dataset.egInit = 'true';

    var track = root.querySelector('[data-eg-track]');
    var prev = root.querySelector('[data-eg-prev]');
    var next = root.querySelector('[data-eg-next]');
    if (!track) return;

    bindVerticalUnlock(track);

    function cardStep() {
      var card = track.querySelector('.elfink-gifts__card');
      if (!card) return track.clientWidth * 0.8;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 12;
      return card.getBoundingClientRect().width + gap;
    }

    function updateNav() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }

    if (prev && next) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
      });

      next.addEventListener('click', function () {
        track.scrollBy({ left: cardStep(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav);
      updateNav();
    }
  }

  function boot() {
    document.querySelectorAll('[data-elfink-gifts]').forEach(initGifts);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('[data-elfink-gifts]')
      : null;
    if (root) {
      root.dataset.egInit = 'false';
      initGifts(root);
    }
  });
})();
